<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="component-details-client">

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Prénom
                </span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input :disabled="disabled" class="w-full" v-model="client.firstName"/>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Nom
                </span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input :disabled="disabled" class="w-full" v-model="client.lastName"/>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
                <span>
                  No. Civique
                </span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input :disabled="disabled" class="w-full" v-model="client.addressNo"/>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Rue
                </span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vue-simple-suggest
          :disabled="disabled"
          :filter-by-query="true"
          :list="streetSuggestions"
          v-model="client.addressStreet">
        </vue-simple-suggest>

        <!--        <vs-input class="w-full" v-model="client.addressStreet" :disabled="disabled"/>-->
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
                <span>
                  No. Appartement
                </span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input :disabled="disabled" class="w-full" v-model="client.addressApp"/>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Ville
                </span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input :disabled="disabled" class="w-full" v-model="client.city"/>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
                <span>
                  Code Postal
                </span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input :disabled="disabled" class="w-full" name="client_postalCode" v-model="client.postalCode"/>
        <span class="text-danger text-sm" v-if="client.postalCode && client.postalCode.length >= 6 && !isValidPostalCode">
                                Le format est invalide
              </span>

      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
                <span>
                  No. Citoyen
                </span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input :disabled="disabled" class="w-full" v-model="client.idCard"/>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
                <span>

                </span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <slot></slot>
      </div>
    </div>


  </div>
</template>

<script>
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/antd.css'
  import VueSimpleSuggest from 'vue-simple-suggest'
  import 'vue-simple-suggest/dist/styles.css'

  export default {
    components: {
      VueSlider,
      VueSimpleSuggest,
    },
    props:      {
      client:            Object,
      streetSuggestions: Array,
      disabled:          {
        type:    Boolean,
        default: false
      },
    },
    data ()
    {
      return {
        mounted: false,
      }
    },
    computed:   {
      activeUserInfo ()
      {
        return this.$store.state.AppActiveUser
      },
      cityConfig ()
      {
        return this.$store.state.cityConfig
      },
      isValidPostalCode ()
      {
        return this.client
          && this.client.postalCode
          && this.client.postalCode.length === 6
          && /^([a-zA-Z][0-9][a-zA-Z][0-9][a-zA-Z][0-9])$/.test(this.client.postalCode)
      },
      canSubmitForm ()
      {
        return !(this.client.postalCode.length === 0
          || this.client.postalCode.length === 0
          || this.client.addressNo.length === 0
          || this.client.addressStreet.length === 0
          || this.client.city.length === 0
          || this.client.firstName.length === 0
          || this.client.lastName.length === 0
          || !this.isValidPostalCode)
      },
    },
    methods:    {

      filterPostalCode (postalCode)
      {
        postalCode = postalCode.toUpperCase()
        postalCode = postalCode.replace(' ', '')

        return postalCode
      },
      init ()
      {
        this.mounted = true
      },
      selectClient (client)
      {
        this.$emit('clientSelected', client)
      },
    },
    watch:      {
      client: {
        deep: true,
        handler ()
        {
          if (this.client && this.client.postalCode)
          {
            this.client.postalCode = this.filterPostalCode(this.client.postalCode)

            console.log(this.client.postalCode, this.isValidPostalCode)
            if (!this.canSubmitForm)
            {
              this.$emit('updated', false)

              return
            }

            this.$emit('updated', this.client)
          } else
          {
            this.$emit('updated', false)
          }
        },
      },
      '$store.state.cityConfig' ()
      {
        this.init()
      },

    },
    mounted ()
    {
      this.init()
    }
  }
</script>

<style lang="scss">
  .vs-dialog {
    max-width: 80% !important;
  }
</style>
